<template>
    <b-card>
        <b-table
            :items="orders"
            :fields="fields"
            :busy="tableLoading"
            small
            striped
            selectable
            select-mode="single"
            responsive
            @row-selected="onRowSelected"
            ref="recentOrdersTable"
        >
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template #head(id)>
                <h6 class="pr-2" style="float: right; font-weight: bold">
                    Total
                </h6>
            </template>

            <template #cell(id)="{ item }">
                <h6 class="pr-2" style="float: right">
                    {{ item | getTotal | formatPrice }}
                </h6>
            </template>
        </b-table>
    </b-card>
</template>

<script>
export default {
    data() {
        return {
            tableLoading: false,
            orders: [],
            fields: [
                { key: 'reference_no', label: 'Ref.' },
                'description',
                {
                    key: 'updated_at',
                    label: 'Date',
                    formatter: value => {
                        const [date] = value.split(' ')
                        return date
                    },
                },
                'id',
            ],
        }
    },
    props: {
        customer_id: { type: Number, require: true },
        order_type_id: { type: Number, require: true },
        value: { type: [Number, null] },
    },
    filters: {
        getTotal(item) {
            return item.items.reduce((_total, item) => {
                const subtotal = item.quantity * item.price
                const tax_cost = (subtotal * item.tax_rate) / 100
                _total += subtotal + tax_cost
                return _total
            }, 0)
        },
        formatPrice: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
    },
    computed: {},
    watch: {
        orders: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        value: function (val) {
            if (!val) {
                this.clearSelected()
            }
        },
    },
    mounted() {
        if (!this.value) {
            this.clearSelected()
        }
        this.doSearch()
    },
    methods: {
        clearSelected() {
            this.$refs.recentOrdersTable &&
                this.$refs.recentOrdersTable.clearSelected()
        },
        onRowSelected(orders) {
            console.log('orders', orders)
            if (orders.length > 0) {
                this.$emit('input', orders[0].id)
                this.$emit('set-items', orders[0].items)
            }
        },
        async doSearch() {
            const { customer_id, order_type_id } = this
            const page = 1
            const completed = 1
            const filters = {
                customer_id,
                order_type_id,
                completed,
            }
            const query = ''
            this.tableLoading = true
            let orders = await this.$store.dispatch('orders/fetchDirect', {
                query,
                filters,
                page,
            })

            orders = orders.filter(x => x.items.length > 0)

            if (orders.length > 5) {
                orders = orders.slice(0, 5)
            }
            this.orders.splice(0, this.orders.length)
            this.orders.push(...orders)
        },
    },
}
</script>

<style>
</style>